var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNewTabIcon = function SvgNewTabIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.125 15c.485 0 .875-.39.875-.875V8h-1.75v5.25H1.75V2.75H7V1H.875A.872.872 0 000 1.875v12.25c0 .485.39.875.875.875h12.25zM8.312 8c.11 0 .226-.041.308-.13l3.193-3.185 1.442 1.435c.082.082.191.13.307.13.247 0 .438-.144.438-.438V1.438A.44.44 0 0013.562 1H9.188c-.294 0-.438.191-.438.438 0 .116.041.225.13.307l1.435 1.442L7.13 6.38a.419.419 0 00-.13.308c0 .109.041.225.13.307l.875.875c.082.089.198.13.307.13z"
  })));
};
export default SvgNewTabIcon;